var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "interviewMailModal",
            "data-focus": "false",
            "data-keyboard": "false",
            "data-backdrop": "static",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog modal-dialog-scrollable" },
            [
              _c("ValidationObserver", {
                ref: "letter",
                staticClass: "modal-content",
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ handleSubmit, reset }) {
                      return [
                        _c("div", { staticClass: "letter-modal" }, [
                          _c(
                            "div",
                            { staticClass: "note-wrap" },
                            [
                              _c("div", { staticClass: "letter-title" }, [
                                _vm._v("面談邀約"),
                              ]),
                              _vm.sendMail
                                ? [
                                    _c("div", { staticClass: "note-title" }, [
                                      _vm._v(
                                        "可動態套入信件內容，請參考以下參數"
                                      ),
                                    ]),
                                    _c("div", { staticClass: "note-table" }, [
                                      _vm.mailParameters
                                        ? _c(
                                            "table",
                                            _vm._l(
                                              _vm.mailParameters,
                                              function (parameter, index) {
                                                return _c(
                                                  "tr",
                                                  { key: index },
                                                  [
                                                    _c("th", [
                                                      _vm._v(
                                                        _vm._s(
                                                          parameter.MailParameterName
                                                        )
                                                      ),
                                                    ]),
                                                    _c("td", [
                                                      _c("span", [
                                                        _vm._v(" {{"),
                                                      ]),
                                                      _vm._v(
                                                        _vm._s(
                                                          parameter.MailParameterCode
                                                        )
                                                      ),
                                                      _c("span", [
                                                        _vm._v("}} "),
                                                      ]),
                                                    ]),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ]),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                          _c(
                            "form",
                            {
                              on: {
                                reset: function ($event) {
                                  $event.preventDefault()
                                  return reset.apply(null, arguments)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "modal-content border-0" },
                                [
                                  _c(
                                    "perfect-scrollbar",
                                    { staticClass: "modal-body" },
                                    [
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v("姓名："),
                                        ]),
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.mail.Interviewee)),
                                        ]),
                                      ]),
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("label", { attrs: { for: "" } }, [
                                          _vm._v("應徵職務："),
                                        ]),
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.mail.Position)),
                                        ]),
                                      ]),
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _vm._v(" 單位面試主管： "),
                                          ]),
                                          _c(
                                            "el-select",
                                            {
                                              staticClass: "w-100",
                                              attrs: {
                                                filterable: "",
                                                clearable: "",
                                                placeholder: "請選擇",
                                              },
                                              model: {
                                                value:
                                                  _vm.mail.InterviewSupervisor,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.mail,
                                                    "InterviewSupervisor",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "mail.InterviewSupervisor",
                                              },
                                            },
                                            _vm._l(
                                              _vm.supervisorOptions,
                                              function (supervisor) {
                                                return _c("el-option", {
                                                  key: supervisor.Guid,
                                                  attrs: {
                                                    label: supervisor.Name,
                                                    value: supervisor.Guid,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _c(
                                              "span",
                                              { staticStyle: { color: "red" } },
                                              [_vm._v("*")]
                                            ),
                                            _vm._v("HR 面試人員： "),
                                          ]),
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              rules: "required",
                                              name: "HR面試人員",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          staticClass: "w-100",
                                                          attrs: {
                                                            filterable: "",
                                                            placeholder:
                                                              "請選擇",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.mail
                                                                .InterviewHR,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.mail,
                                                                "InterviewHR",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "mail.InterviewHR",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.supervisorOptions,
                                                          function (
                                                            supervisor
                                                          ) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: supervisor.Guid,
                                                                attrs: {
                                                                  label:
                                                                    supervisor.Name,
                                                                  value:
                                                                    supervisor.Guid,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                          staticStyle: {
                                                            "font-size": "13px",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("ValidationProvider", {
                                            staticClass: "w-100",
                                            attrs: {
                                              rules: "required",
                                              name: "面談日期",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c(
                                                        "label",
                                                        { attrs: { for: "" } },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                color: "red",
                                                              },
                                                            },
                                                            [_vm._v("*")]
                                                          ),
                                                          _vm._v("面談日期： "),
                                                        ]
                                                      ),
                                                      _c("date-picker", {
                                                        staticClass: "w-100",
                                                        attrs: {
                                                          id: "reportDate",
                                                          format: "YYYY-MM-DD",
                                                          valueType: "format",
                                                          placeholder:
                                                            "YYYY-MM-DD",
                                                          "disabled-date":
                                                            _vm.$common
                                                              .disabledDateBeforeToday,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.mail
                                                              .InterviewDate,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.mail,
                                                              "InterviewDate",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "mail.InterviewDate",
                                                        },
                                                      }),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                          staticStyle: {
                                                            "font-size": "13px",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("ValidationProvider", {
                                            attrs: {
                                              rules: "required",
                                              name: "面談時間",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c(
                                                        "label",
                                                        {
                                                          attrs: {
                                                            for: "reportTime",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                color: "red",
                                                              },
                                                            },
                                                            [_vm._v("*")]
                                                          ),
                                                          _vm._v("面談時間： "),
                                                        ]
                                                      ),
                                                      _c("date-picker", {
                                                        staticClass: "w-100",
                                                        attrs: {
                                                          id: "reportTime",
                                                          format: "HH:mm",
                                                          "value-type":
                                                            "format",
                                                          type: "time",
                                                          "default-value":
                                                            new Date().setHours(
                                                              8,
                                                              0,
                                                              0,
                                                              0
                                                            ),
                                                          "minute-step": 5,
                                                          placeholder: "HH:mm",
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.mail
                                                              .InterviewTime,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.mail,
                                                              "InterviewTime",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "mail.InterviewTime",
                                                        },
                                                      }),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                          staticStyle: {
                                                            "font-size": "13px",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("ValidationProvider", {
                                            attrs: {
                                              rules: "required",
                                              name: "面談地點",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c(
                                                        "label",
                                                        { attrs: { for: "" } },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                color: "red",
                                                              },
                                                            },
                                                            [_vm._v("*")]
                                                          ),
                                                          _vm._v("面談地點： "),
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-select",
                                                        {
                                                          staticClass: "w-100",
                                                          attrs: {
                                                            filterable: "",
                                                            placeholder:
                                                              "請選擇",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.mail
                                                                .InterviewPlace,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.mail,
                                                                "InterviewPlace",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "mail.InterviewPlace",
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.interviewPlaceOptions,
                                                          function (place) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: place.Guid,
                                                                attrs: {
                                                                  label:
                                                                    place.Name,
                                                                  value:
                                                                    place.Name,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      ),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                          staticStyle: {
                                                            "font-size": "13px",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "form-group" },
                                        [
                                          _c("label", { attrs: { for: "" } }, [
                                            _c(
                                              "span",
                                              { staticClass: "mark" },
                                              [_vm._v("*")]
                                            ),
                                            _vm._v("是否發送信件："),
                                          ]),
                                          _c(
                                            "el-select",
                                            {
                                              staticClass: "w-100",
                                              attrs: { clearable: false },
                                              model: {
                                                value: _vm.sendMail,
                                                callback: function ($$v) {
                                                  _vm.sendMail = $$v
                                                },
                                                expression: "sendMail",
                                              },
                                            },
                                            [
                                              _c("el-option", {
                                                attrs: {
                                                  label: "是",
                                                  value: true,
                                                },
                                              }),
                                              _c("el-option", {
                                                attrs: {
                                                  label: "否",
                                                  value: false,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm.sendMail
                                        ? [
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  { attrs: { for: "" } },
                                                  [_vm._v("面談說明：")]
                                                ),
                                                _c("textarea", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: _vm.mail.Remark,
                                                      expression: "mail.Remark",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "form-control w-100",
                                                  attrs: {
                                                    rows: "3",
                                                    maxlength: "10000",
                                                  },
                                                  domProps: {
                                                    value: _vm.mail.Remark,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        _vm.mail,
                                                        "Remark",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  { attrs: { for: "" } },
                                                  [_vm._v("附件：")]
                                                ),
                                                _c(
                                                  "el-upload",
                                                  {
                                                    staticClass: "upload-demo",
                                                    attrs: {
                                                      action: "",
                                                      "auto-upload": false,
                                                      "show-file-list": false,
                                                      "on-change":
                                                        _vm.uploadFile,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          size: "small",
                                                          type: "primary",
                                                        },
                                                      },
                                                      [_vm._v(" 點擊上傳 ")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm.uploadFileList
                                                  ? _vm._l(
                                                      _vm.uploadFileList,
                                                      function (file) {
                                                        return _c(
                                                          "div",
                                                          {
                                                            key: file.FileGuid,
                                                          },
                                                          [
                                                            _c(
                                                              "p",
                                                              {
                                                                staticStyle: {
                                                                  "margin-top":
                                                                    "20px",
                                                                  cursor:
                                                                    "pointer",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.$common.downloadFile(
                                                                        {
                                                                          fileGuid:
                                                                            file.FileGuid,
                                                                          fileType:
                                                                            file.FileContentType,
                                                                        }
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("eva-icon", {
                                                                  attrs: {
                                                                    fill: "#000",
                                                                    name: "attach-outline",
                                                                  },
                                                                }),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "margin-left":
                                                                          "15px",
                                                                        "vertical-align":
                                                                          "text-top",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          file.FileName
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        display:
                                                                          "inline-block",
                                                                        position:
                                                                          "absolute",
                                                                        right:
                                                                          "25px",
                                                                      },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          $event.stopPropagation()
                                                                          return _vm.removeFile(
                                                                            {
                                                                              fileGuid:
                                                                                file.FileGuid,
                                                                              fileGroupGuid:
                                                                                file.FileGroupGuid,
                                                                            }
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "eva-icon",
                                                                      {
                                                                        attrs: {
                                                                          fill: "#000",
                                                                          name: "trash-2-outline",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  : _vm._e(),
                                              ],
                                              2
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c(
                                                  "label",
                                                  { attrs: { for: "" } },
                                                  [_vm._v(" 信件範本： ")]
                                                ),
                                                _c(
                                                  "el-select",
                                                  {
                                                    staticClass: "w-100",
                                                    attrs: {
                                                      filterable: "",
                                                      clearable: "",
                                                      placeholder: "請選擇",
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.getMailTemplateDetail,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.selectedTemplateGuid,
                                                      callback: function ($$v) {
                                                        _vm.selectedTemplateGuid =
                                                          $$v
                                                      },
                                                      expression:
                                                        "selectedTemplateGuid",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.mailTemplates,
                                                    function (template) {
                                                      return _c("el-option", {
                                                        key: template.MailTemplateGuid,
                                                        attrs: {
                                                          label:
                                                            template.MailTemplateName,
                                                          value:
                                                            template.MailTemplateGuid,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("ValidationProvider", {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    rules: "required",
                                                    name: "信件主旨",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function ({
                                                          errors,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "label",
                                                              {
                                                                attrs: {
                                                                  for: "",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "mark",
                                                                  },
                                                                  [_vm._v("*")]
                                                                ),
                                                                _vm._v(
                                                                  "信件主旨： "
                                                                ),
                                                              ]
                                                            ),
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm.mail
                                                                      .MailSubject,
                                                                  expression:
                                                                    "mail.MailSubject",
                                                                },
                                                              ],
                                                              staticClass:
                                                                "form-control w-100",
                                                              attrs: {
                                                                placeholder:
                                                                  "請輸入信件主旨或選擇範本",
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm.mail
                                                                    .MailSubject,
                                                              },
                                                              on: {
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    )
                                                                      return
                                                                    _vm.$set(
                                                                      _vm.mail,
                                                                      "MailSubject",
                                                                      $event
                                                                        .target
                                                                        .value
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "13px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      errors[0]
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "form-group" },
                                              [
                                                _c("ValidationProvider", {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    rules: "required",
                                                    name: "信件內容",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function ({
                                                          errors,
                                                        }) {
                                                          return [
                                                            _c(
                                                              "label",
                                                              {
                                                                attrs: {
                                                                  for: "",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "mark",
                                                                  },
                                                                  [_vm._v("*")]
                                                                ),
                                                                _vm._v(
                                                                  "信件內容： "
                                                                ),
                                                              ]
                                                            ),
                                                            _c("VueEditor", {
                                                              staticStyle: {
                                                                background:
                                                                  "rgb(255, 255, 255)",
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.mail
                                                                    .MailTemplateBody,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.mail,
                                                                      "MailTemplateBody",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "mail.MailTemplateBody",
                                                              },
                                                            }),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "text-danger",
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "13px",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      errors[0]
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                  _c("div", { staticClass: "modal-footer" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-secondary",
                                        attrs: { type: "reset" },
                                        on: { click: _vm.closeInterviewModal },
                                      },
                                      [_vm._v(" 取消 ")]
                                    ),
                                    _vm.sendMail
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "btn btn-primary",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function ($event) {
                                                return handleSubmit(_vm.preview)
                                              },
                                            },
                                          },
                                          [_vm._v(" 預覽 ")]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-success",
                                        attrs: {
                                          type: "button",
                                          disabled: _vm.clickDisabled,
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.clickDisabled = true
                                            _vm.updateLoading(true)
                                            handleSubmit(
                                              _vm.sendInterviewInvitation
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" 寄出 ")]
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]
      ),
      _c("PreviewMailModal", {
        attrs: { type: "interview", mail: _vm.previewData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }